import './Divider.scss'
import React from 'react'
import PropTypes from 'prop-types'

// Divider :: () -> React.Component
const Divider = ({
  variant = 'default',
  visibility = 'mobile',
}) => <hr className={ `widget-layout-divider ${ variant } visibility-${visibility}` } />

Divider.propTypes = {
  variant: PropTypes.oneOf(['default', 'hidden-web', 'thin']),
  visibility: PropTypes.oneOf(['mobile', 'all', 'none']),
}

export default Divider
